import { trackingEvent } from '@notino/web-tracking';

import { getTrackingProductName } from '@utils/tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { ECartType, EcommerceSectionNamespace, IEcommerceCheckout } from '../../model';

export const trackViewCartEvent = ({
  revenue,
  tax,
  totalValue,
  products,
  services,
  freeDelivery,
}: IEcommerceCheckout) => {
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.VIEW_CART,
      checkout: {
        cart_type: ECartType.Cart,
        products: products.map((product) => ({
          product_code: product.productCode,
          product_name: getTrackingProductName(product),
          brand_name: product.brandName,
          primary_category: product.primaryCategories.category,
          primary_subcategory: product.primaryCategories.subCategory,
          primary_type: product.primaryCategories.type,
          kind: product.primaryCategories.kind,
          full_price: product.fullPrice,
          availability: product.stockAvailability,
          price: product.price,
          quantity: product.quantity,
          group: product.group,
        })),
        step: EcommerceSectionNamespace.EEcommerceStepNumber.CART,
        revenue: revenue.toString(),
        tax: tax.toString(),
        total_value: totalValue.toString(),
        free_delivery: freeDelivery ?? false,
      },
      services: services?.some((service) => service !== '') ? services : [],
      _clear: true,
    }),
  );
};
